import { ProductPageGeneralCopy } from '@/lib/contentful';

export const getProductPageTranslation = (
  translations: ProductPageGeneralCopy | null,
  key: string,
) => {
  if (!translations) return key;

  return translations[key] || key;
};
